
    export default {
        name: "FiveStarProductsInsurerHead",
        props: {
            anchorLink: {
                type: String,
                default: '#'
            },
            data: {
                type: Object,
                default: () => ({})
            },
            dataLanguageSwitchLangCode: {
                type: String,
                default: ''
            },
            dataLanguageSwitchText: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                protectionLists: [ 
                    { title: 'dfdfdf'},
                    { title: 'dfdfdf'},
                    { title: 'dfdfdf'},
                    { title: 'dfdfdf'},
                    { title: 'dfdfdf'},
                ],
                isActive: false,
                currentSlug: this.$route?.params?.productCat,
                productSubCatSlug: this.$route?.params?.productSubCat
            }
        },
        computed: {
            rightImageScr() {
                return this.data?.headImage?.url;
            },
        },
        watch: {
            '$route.query.lang' (newVal, oldVal) {
                if (newVal !== oldVal) {
                    location.reload();
                }
            },
        },
        methods: {
            clickToSelect(slug) {
                this.$router.push({path: this.localePath('/happy-kids/' + this.$route.params.year + slug + '/' + this.data?.defaultCoverage?.Slug)})
                this.isActive = !this.isActive;
            },
            iconSrc(icon) {
                return require(`@/assets/images/family/icon/${icon}.png`)
            },
            isSCCode(code) {
            return code?.toLowerCase()  === 'sc'
            },
        }
    }
